import { State } from "../../types";
import { GetHighlightedText } from "../../Document/getHighlightedText";
import { getConfidenceClass } from "../../Document/getConfidenceClass";

export type UpdateAnswerValueAction = Readonly<{
  key: string;
  type: "UPDATE ANSWER VALUE";
  value: any;
  valueRaw: string;
}>;

export const updateAnswerValue = (state: State, action: UpdateAnswerValueAction): State => {  
  if (!(action.key in state.values)) {
    return state;
  }
  const newState = {
    ...state,
    activeValue: action.key,
    modified: true,
    values: {
      ...state.values,
      [action.key]: {
        ...state.values[action.key],
        confidence: 1.0,
        value: action.value,
        valueRaw: action.valueRaw,
      },
    },
  };
  const idRef = newState.values[action.key].idRef;
  let blocks = newState.blocks;
  if (idRef && idRef in blocks && blocks[idRef]) {
    blocks = {
      ...blocks,
      [idRef]: {
        ...blocks[idRef],
        confidenceClass: getConfidenceClass(blocks[idRef], newState.confidenceThreshold, newState.values),
        highlights: GetHighlightedText(blocks[idRef], newState.taxonomy.taxonomyObject, newState.values),
      },
    };
  }
  return {
    ...newState,
    blocks
  };
};
